import React from 'react';
import Link from 'next/link';

import { ConditionalWrapper } from 'shared/components/conditional-wrapper';

type ConditionalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
  url: string | null;
};

export const ConditionalLink = ({ url, children, ...anchorProps }: ConditionalLinkProps): JSX.Element => (
  <ConditionalWrapper
    condition={!!url}
    wrapper={(wrapperChildren) => {
      // If any direct child is already an anchor (including styled components targeting 'a'),
      // do not inject another <a>; rely on legacyBehavior + passHref
      const childrenArray = React.Children.toArray(wrapperChildren);
      const hasAnchorChild = childrenArray.some((child) => {
        if (!React.isValidElement(child)) {
          return false;
        }
        const { type } = child as any;
        return (typeof type === 'string' && type === 'a') || type?.target === 'a';
      });

      if (hasAnchorChild) {
        return (
          <Link href={url ?? ''} legacyBehavior passHref>
            {wrapperChildren as any}
          </Link>
        );
      }

      return (
        <Link href={url ?? ''} legacyBehavior passHref>
          <a {...anchorProps}>{wrapperChildren}</a>
        </Link>
      );
    }}
  >
    {children}
  </ConditionalWrapper>
);
